import { Contract, Document } from 'src/DTO/Document.type';
import { Job } from 'src/DTO/Job.type';
import { POOL_STATUS } from 'src/DTO/PoolStatus.enum';
import { Role } from 'src/DTO/Role.type';
import { WorkerInterview } from 'src/DTO/WorkerInterview.type';
import { WorkerProfile } from 'src/DTO/WorkerProfile.type';

export enum WorkerScope {
  INVITED = 'invited',
  AVAILABLE = 'available',
}

export interface InviteWorkerPayload {
  phoneNumber: string;
  name: string;
  shouldNotify: boolean;
}

export interface ResendWorkerInvitePayload {
  workerId: string;
}

export interface RemoveWorkerPayload {
  workerId: string;
}

export interface WorkerInterviewResponse extends Pick<WorkerInterview, 'id' | 'interviewId'> {
  job: Pick<Job, 'id'> & { role: Pick<Role, 'id' | 'name'> };
}

export interface GetWorkerByIdResponse {
  worker: WorkerProfile;
  interviews: WorkerInterviewResponse[];
}
export interface GetWorkerByIdPayload {
  id: string;
}

export type GetWorkerDocumentsPayload = GetWorkerByIdPayload;

export type GetWorkerDocumentsResponse = Document[];

export type GetWorkerContractsPayload = GetWorkerByIdPayload;

export interface GetWorkerContractsResponse {
  workerContracts: Contract[];
}

export interface WorkerFilters {
  preferredLocations?: string;
  name?: string;
  phoneNumber?: string;
  interviewId?: boolean;
  poolStatus?: POOL_STATUS;
}

export interface GetWorkersPayload {
  currentPage: number;
  jobId?: string;
  filters?: WorkerFilters;
}

export interface GetWorkersResponse {
  finalizedWorkers: WorkerProfile[];
  totalPageCount: number;
  filteredWorkersCount: number;
  totalWorkersCount: number;
}
